export default function MoreStories({ posts, reviews }) {
  // Helper function to render stars based on the average rating
  const renderStars = (averageRating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5"
        fill={index < averageRating ? "#FF9346" : "none"} // Filled if index is less than rating
        stroke={index < averageRating ? "#FF9346" : "#ccc"} // Gray stroke for empty stars
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ));
  };

  return (
    <div className="more-stories grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
      {posts.map((post) => {
        const postId = post?.id; // Safely access post.id

        return (
          <div
            key={post.slug}
            className="post bg-white rounded-lg shadow-md overflow-hidden"
          >
            <img
              src={post.feature_image}
              alt={post.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <a href={`/blogs/posts/${post.slug}`}>
                <h3 className="text-xl font-semibold mb-2 text-gray-800 line-clamp-2">
                  {post.title}
                </h3>
              </a>
              <p className="text-gray-600 mb-4 line-clamp-3 text-justify">
                {post.excerpt}
              </p>

              {/* Average Rating with Stars */}
              <div className="flex items-center mb-2">
                {renderStars(reviews[postId] || 0)}
              </div>

              <a href={`/blogs/posts/${post.slug}`} className="text-white">
                <button className="bg-[#2e807a] rounded-3xl px-4 py-2">
                  Read More
                </button>
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
}
